import {useSearchParams} from 'react-router-dom';
import {useState, useEffect} from 'react';

import ResetPasswordHeader from "./components/header";
import ResetPasswordMain from "./components/main";
import ResetPasswordFooter from "./components/footer";

import ResetPasswordSuccessMain from "./components/success-main";

import ResetPasswordLoading from "./components/loading"

function ResetPasswordPage() {
    const [isReady, setIsReady] = useState(false)

    const [showAlertOK, setShowAlertOK] = useState(false)
    const [showAlertERROR, setShowAlertERROR] = useState(false)

    const [showSuccessPage, setShowSuccessPage] = useState(false)

    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const handleResetPassword = async (password) => {
        const response = await fetch('/api/reset-password', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({token: token, password: password}),
        });

        const data = await response.json();
        console.log(data)

        if (response.ok) {
            setShowAlertOK(true)

            setTimeout(function() {
                setShowSuccessPage(true)
            }, 2500)
        } else {
            setShowAlertERROR(true)
        }
    };

    useEffect(() => {
        if (token !== null && token !== undefined && token !== "") {
            setIsReady(true)
        }
    }, [token])

    if (!isReady) {
        return <ResetPasswordLoading />
    }

    return (
        <>
        <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden">
            <ResetPasswordHeader/>
            {showSuccessPage ? <ResetPasswordSuccessMain/> : <ResetPasswordMain handleResetPassword={handleResetPassword}/>}
            <ResetPasswordFooter/>
        </div>

        {showAlertOK && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-green text-sm right-[10px] top-[10px] select-none animate-[show-alert_3s_ease-in-out_forwards]">Account password changed</span>}
        {showAlertERROR && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-red text-sm right-[10px] top-[10px] select-none animate-[show-alert_3s_ease-in-out_forwards]">Error during the password changing, retry</span>}
        </>
    );
}


export default ResetPasswordPage;